module.exports = __webpack_public_path__ + "static/06-af68514246b151aa0474d81dfeb4583d.jpg";